export const PM_ROUTES = {
  pmRoot: "/employee/pm",
  myProjects: "/employee/pm/projects",
  createProject: "/employee/pm/project/create",
  projectDetails: "/employee/pm/project/details",
  createInstallationPlan: "/employee/pm/project/installation-plan/create",
} as const;
